<template>
  <div class="pt60">
    <div class="board">
      <ul class="boardwrt">
        <li class="w160">{{$t('front.board.type')}}</li>
        <li class="w100w">
          <select v-model="model.type">
            <template v-for="type in typeList" v-bind:key="type">
              <option :value="type">{{$t('front.qnaTypeCategory.' + type)}}</option>
            </template>
          </select>
        </li>
      </ul>
      <ul class="boardwrt">
        <li class="w160">{{$t('front.board.title')}}</li>
        <li class="w100w"><input type="" :placeholder="$t('front.board.emptyTitle')" v-model="model.title"/></li>
      </ul>
      <ul class="boardwrt">
        <li class="w160">{{$t('front.search.content')}}</li>
        <li class="w100w"><textarea
          :placeholder="$t('front.board.commentPlaceholder')" v-model="model.content"></textarea></li>
      </ul>
    </div>

    <div class="boardbtn">
      <ui-button :className="'grsbtn mr5'" :text="$t('front.board.apply')" @click="onClickSubmit"/>
      <ui-button :className="'grsbtn'" :text="$t('front.board.cancel')" @click="onClickCancel"/>
    </div>

  </div>
</template>

<script>
import UiButton from '@/components/ui/UiButton'

export default {
  name: 'qnaWrite',
  components: {
    UiButton
  },
  data () {
    return {
      categoryList: [
        'livecasino',
        'slot',
        'sports',
        'esports',
        'minigame',
        'virtualgame',
        'cash',
        'betting',
        'etc'
      ],
      typeList: [
        'bankaccount',
        'etc'
      ],
      model: {
        category: '',
        type: 'etc',
        title: '',
        content: ''
      }
    }
  },
  created () {
  },
  methods: {
    onClickCancel () {
      this.$router.go(-1)
    },
    onClickSubmit () {
      if (!this.model.title) {
        this.onAlert('warningart', 'front.board.emptyTitle')
        return false
      }

      if (!this.model.content) {
        this.onAlert('warningart', 'front.board.emptyContent')
        return false
      }

      const params = {
        title: this.model.title,
        content: this.model.content,
        boardType: 'faq',
        category: this.model.category,
        faqType: this.model.type
      }
      if (this.boardIdx) {
        params.boardIdx = this.boardIdx
      }
      this.setSaveBoard(params)
    }
  }
}
</script>

<style scoped src="@/styles/common.css"></style>
<style scoped src="@/styles/subcommon.css"></style>
<style scoped>
/* 1:1 문의 작성 - 화이트 카드형 보정
   template/script 구조는 유지하고 입력 폼 쉐입만 정리 */

.pt60 {
  padding-top: 24px !important;
}

.board {
  width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  border: 1px solid #dbe3ef !important;
  border-radius: 12px !important;
  background: #ffffff !important;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05) !important;
  overflow: hidden !important;
  box-sizing: border-box !important;
}

.boardwrt {
  display: grid !important;
  grid-template-columns: 138px minmax(0, 1fr) !important;
  align-items: stretch !important;
  min-height: 56px !important;
  margin: 0 !important;
  padding: 0 !important;
  border-bottom: 1px solid #dfe6ef !important;
  background: #ffffff !important;
  list-style: none !important;
  box-sizing: border-box !important;
}

.boardwrt:first-child {
  border-top: 3px solid #2f6df6 !important;
}

.boardwrt:last-child {
  border-bottom: 0 !important;
}

.boardwrt > li {
  display: flex !important;
  align-items: center !important;
  min-width: 0 !important;
  margin: 0 !important;
  box-sizing: border-box !important;
}

.boardwrt .w160 {
  width: auto !important;
  min-width: 0 !important;
  justify-content: center !important;
  padding: 0 18px !important;
  border-right: 1px solid #dfe6ef !important;
  background: #f8fafc !important;
  color: #111827 !important;
  font-size: 14px !important;
  font-weight: 900 !important;
  text-align: center !important;
}

.boardwrt .w100w {
  width: 100% !important;
  padding: 10px 12px !important;
  background: #ffffff !important;
}

.boardwrt select,
.boardwrt input,
.boardwrt textarea {
  width: 100% !important;
  min-width: 0 !important;
  border: 1px solid #d4ddeb !important;
  border-radius: 7px !important;
  background: #ffffff !important;
  color: #263244 !important;
  font-size: 14px !important;
  line-height: 1.4 !important;
  outline: none !important;
  box-shadow: none !important;
  box-sizing: border-box !important;
}

.boardwrt select,
.boardwrt input {
  height: 34px !important;
  padding: 0 12px !important;
}

.boardwrt select {
  max-width: 150px !important;
  cursor: pointer !important;
}

.boardwrt textarea {
  min-height: 230px !important;
  padding: 13px 14px !important;
  resize: vertical !important;
}

.boardwrt input:focus,
.boardwrt select:focus,
.boardwrt textarea:focus {
  border-color: #5d8df6 !important;
  box-shadow: 0 0 0 3px rgba(93, 141, 246, 0.14) !important;
}

.boardwrt input::placeholder,
.boardwrt textarea::placeholder {
  color: #8b97a8 !important;
}

.boardbtn {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
  margin: 22px 0 0 !important;
  padding: 0 !important;
}

.boardbtn :deep(button),
.boardbtn :deep(a),
.boardbtn :deep(.grsbtn) {
  min-width: 138px !important;
  height: 36px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 18px !important;
  border: 1px solid #5969d7 !important;
  border-radius: 6px !important;
  background: #5969d7 !important;
  color: #ffffff !important;
  font-size: 14px !important;
  font-weight: 900 !important;
  line-height: 36px !important;
  text-decoration: none !important;
  cursor: pointer !important;
  box-shadow: 0 8px 16px rgba(89, 105, 215, 0.16) !important;
  box-sizing: border-box !important;
}

.boardbtn :deep(button:hover),
.boardbtn :deep(a:hover),
.boardbtn :deep(.grsbtn:hover) {
  border-color: #4656c6 !important;
  background: #4656c6 !important;
}

.boardbtn :deep(.mr5) {
  margin-right: 0 !important;
}

@media (max-width: 1000px) {
  .pt60 {
    padding-top: 16px !important;
  }

  .boardwrt {
    grid-template-columns: 1fr !important;
  }

  .boardwrt .w160 {
    justify-content: flex-start !important;
    min-height: 42px !important;
    border-right: 0 !important;
    border-bottom: 1px solid #dfe6ef !important;
  }

  .boardwrt .w100w {
    padding: 10px !important;
  }

  .boardwrt select {
    max-width: none !important;
  }

  .boardwrt textarea {
    min-height: 180px !important;
  }

  .boardbtn {
    margin-top: 18px !important;
  }

  .boardbtn :deep(button),
  .boardbtn :deep(a),
  .boardbtn :deep(.grsbtn) {
    min-width: 120px !important;
  }
}
</style>
